import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GreenleafCustomerSummaryReport } from './Pages'

export const GreenleafCustomerSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GreenleafCustomerSummaryReport} />
    </Fragment>
)